import { StandaloneLoopAround, StandaloneLoopAroundProps } from '@/components/LoopAround';
import { LabradorComponent, StandaloneComponent } from '@/types/component';

const HantStandaloneLoopAround: StandaloneComponent<StandaloneLoopAroundProps> = (props) => {
  return <StandaloneLoopAround {...props} velocity={-0.7} />;
};

export const standalone = HantStandaloneLoopAround;

const HantLabradorLoopAround: LabradorComponent = () => <HantStandaloneLoopAround />;

export default HantLabradorLoopAround;
